"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.configureSessions = void 0;
const session_1 = require("../session");
const helper_1 = require("../initializer/asis/helper");
const storage_1 = require("../session/cc/storage");
const storage_2 = require("../session/web/storage");
const storage_3 = require("../session/asis/storage");
const store_1 = require("../store");
const features_1 = require("../features");
const mobileConnector_1 = require("../mobileConnector");
const session_utils_1 = require("./utils/session.utils");
const configureSessions = (sessionStore = (0, store_1.getDefaultCookiesStore)({ credentialsDomain: window.LOGIN_DOMAIN, secure: session_utils_1.isSecureEnvironment })) => {
    return {
        HybridSession: new session_1.MbHybridSession(new features_1.SessionStorage((0, store_1.getDefaultMemoryStore)()), mobileConnector_1.refreshToken),
        CCSession: new session_1.MbCCDevSession(new storage_1.MbCCSessionStorage((0, store_1.getDefaultCookiesStore)())),
        Session: new session_1.MbSession(new storage_2.MbSessionStorage(sessionStore)),
        AsisSession: new session_1.MbAsisSession(new storage_3.MbAsisSessionStorage((0, store_1.getDefaultCookiesStore)({ credentialsDomain: (0, helper_1.getCookieDomain)('openbank.es') }))),
    };
};
exports.configureSessions = configureSessions;
//# sourceMappingURL=session.js.map